import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Box, Card, CardContent, Divider, CardHeader } from '@mui/material';
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify';

function InventoryAnalysis() {
  const [items, setItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredItems, setFilteredItems] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Fetch data from the API
  useEffect(() => {
    axios.get('https://serveremilia.mylksystems.com/sales/RemainingItemSales')
      .then((response) => {
        setItems(response.data);
        setFilteredItems(response.data);
      })
      .catch((error) => {
        console.error('Error fetching inventory data:', error);
      });
  }, []);

  // Handle search input change
  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);

    // Filter the items based on the search term (itemId or barcode)
    const filtered = items.filter(item =>
      item.itemId.toString().includes(value) ||
      item.itemName.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredItems(filtered);
  };

  // Handle CSV download
  const handleDownloadCSV = () => {
    const csvContent = [
      ['Barcode Id', 'Item Name', 'Total Quantity', 'Remaining Quantity', 'Cost Price', 'Selling Price'],
      ...filteredItems.map(item => [
        item.itemId,
        item.itemName,
        item.TotalQuantity,
        item.RemainingQuantity,
        item.costPrice,
        item.sellingPrice,
      ]),
    ];

    const csvString = csvContent.map(row => row.join(',')).join('\n');
    const blob = new Blob([csvString], { type: 'text/csv' });
    saveAs(blob, 'inventory_analysis.csv');
  };

  // Handle page change in the table
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Box p={3}>
      <Card>
        <CardHeader title="Inventory Analysis" />
        <CardContent>
          <Box display="flex" justifyContent="space-between" mb={2}>
            <TextField
              label="Search by Barcode or Item Name"
              variant="outlined"
              value={searchTerm}
              onChange={handleSearchChange}
              fullWidth
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleDownloadCSV}
              sx={{ ml: 2 }}
            >
              Download CSV
            </Button>
          </Box>

          <Divider />

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Barcode Id</TableCell>
                  <TableCell>Item Name</TableCell>
                  <TableCell>Total Quantity</TableCell>
                  <TableCell>Remaining Quantity</TableCell>
                  <TableCell>Cost Price</TableCell>
                  <TableCell>Selling Price</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredItems
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item) => (
                    <TableRow key={item.itemId}>
                      <TableCell>{item.itemId}</TableCell>
                      <TableCell>{item.itemName}</TableCell>
                      <TableCell>{item.TotalQuantity}</TableCell>
                      <TableCell>{item.RemainingQuantity}</TableCell>
                      <TableCell>{item.costPrice}</TableCell>
                      <TableCell>{item.sellingPrice}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredItems.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </CardContent>
      </Card>
    </Box>
  );
}

export default InventoryAnalysis;
